import { NextPage } from 'next'
import { PageForgotTeamId } from 'src/components/pages'

type InitialProps = {}

type Props = {} & InitialProps

const Index: NextPage<Props> = (_: Props) => {
  return <PageForgotTeamId />
}

export default Index
